import {whenSeen} from '../assets/modules/github/behaviors/dynamic-elements'

whenSeen('readme-toc', () => import('./files/readme-toc-element'))
whenSeen('launch-code', () => import('./account_verifications/launch-code-element'))
whenSeen('severity-calculator', () => import('./advisories/severity-calculator-element'))
whenSeen('metric-selection', () => import('./advisories/metric-selection-element'))
whenSeen('delayed-loading', () => import('./github/delayed-loading-element'))
whenSeen('feature-callout', () => import('./github/feature-callout-element'))
